
//Components
import NavSection from './Components/NavSection';
import Introduction from './Components/Introduction';
import Experiences from './Components/Experiences';
import AboutMeSection from './Components/AboutMeSection';
import ProjectSection from './Components/ProjectSection';
import Footer from './Components/Footer';
import Skills from './Components/Skills';

import './firebase/firebaseConfig';


function App() {
  return (
    <div id="Home" className="App">
      <NavSection/>
      <Introduction/>
      <Experiences/>
      <AboutMeSection/>
      <Skills/>
      <ProjectSection/>
      <Footer/>

    </div>
  );
}

export default App;
